export default __webpack_public_path__ + "static/media/19.bec48b04.png";